
import React from 'react';
import MaintenanceHeader from './maintenance/MaintenanceHeader';
import MaintenanceTabs from './maintenance/MaintenanceTabs';

const MaintenanceSection = () => {
  return (
    <div className="mb-8 rounded-lg bg-white dark:bg-gray-800 shadow-sm border border-gray-100 dark:border-gray-700">
      <MaintenanceHeader title="Preventive & Predictive Maintenance" />
      <div className="max-h-[520px] overflow-auto scrollbar-thin scrollbar-thumb-gray-200 dark:scrollbar-thumb-gray-700 scrollbar-track-transparent">
        <MaintenanceTabs />
      </div>
    </div>
  );
};

export default MaintenanceSection;
